<template>
  <div>
    <a-layout>
      <a-layout-header>
        <HeaDer />
      </a-layout-header>
      <a-layout-content>
        <router-view />
      </a-layout-content>
    </a-layout>
  </div>
</template>


<script>
import HeaDer from "./layout/HeaDer.vue";
export default {
  name: "HomePage",
  components: {
    HeaDer,
  },
};
</script>

<style>
</style>
